
export { VTable, Grid } from './VTable2.0';

import { VTable as VTablePro, Grid as GridPro, utils } from './VTable2.0';
export {
  VTablePro,
  GridPro,
  utils
};

